module.exports = __webpack_public_path__ + "assets/img/rct3.128a434b.png";